import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SmartphoneStrokeIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M6.8926 23C6.37485 23 5.92999 22.8109 5.55799 22.4329C5.186 22.0548 5 21.6026 5 21.0764V2.92364C5 2.3974 5.186 1.94524 5.55799 1.56714C5.92999 1.18905 6.37485 1 6.8926 1H17.1074C17.6251 1 18.07 1.18905 18.442 1.56714C18.814 1.94524 19 2.3974 19 2.92364V21.0764C19 21.6026 18.814 22.0548 18.442 22.4329C18.07 22.811 17.6251 23 17.1074 23L6.8926 23ZM6.8926 18.8909V21.0764H17.1074V18.8909H6.8926ZM12.0042 20.7121C12.2084 20.7121 12.3783 20.6419 12.5137 20.5015C12.649 20.361 12.7167 20.187 12.7167 19.9794C12.7167 19.7718 12.6476 19.5992 12.5095 19.4616C12.3713 19.324 12.2001 19.2552 11.9958 19.2552C11.7916 19.2552 11.6217 19.3254 11.4864 19.4659C11.351 19.6063 11.2833 19.7803 11.2833 19.9879C11.2833 20.1955 11.3524 20.3681 11.4905 20.5057C11.6287 20.6433 11.7999 20.7121 12.0042 20.7121ZM6.8926 17.434H17.1074V5.10906H6.8926V17.434ZM6.8926 3.65211H17.1074V2.92364H6.8926V3.65211Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
